import React from 'react';
import ComingSoon from '@/components/shared/ComingSoonSection';
import './ReportsPage.scss';

const ReportsPage = () => {
  return (
    <div className="ReportsPage">
      <ComingSoon title="ReportsPage" />
    </div>
  );
};

export default ReportsPage;